/**
 * Shared avatar / display-name helpers for the patient surfaces.
 *
 * The app top-bar avatar (PatientLayout) and the coach message avatars derive
 * their name and initials from the same rule, so they stay in sync — e.g. when
 * a user renames themselves in Settings, both follow.
 */

interface NameSources {
  /** Settings-chosen name (patient_intake.display_name). Takes precedence. */
  displayName?: string | null
  /** Clerk sign-up full name. */
  fullName?: string | null
  /** Fallback identifier. */
  email?: string | null
}

/** Resolve the name shown for a patient, preferring their Settings display name. */
export function patientDisplayName({ displayName, fullName, email }: NameSources): string {
  return displayName?.trim() || fullName || email || '?'
}

/** Up-to-two-letter initials from a name, e.g. "Anmol Multani" → "AM". */
export function initialsFor(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
